import type { WinningType } from '../../../types'
import { WinningDescription } from '../WinningDescription'
import React from 'react'
import type { Gain } from 'shared/store/tu-preferes-king/types'
import styled from 'styled-components'
import { CardWithWinning } from 'app/tu-preferes-king/components/CardWithWinning'
import { breakpoints } from 'app/assets/styles'

export type WinningProps = {
    winning?: Gain,
    type: WinningType,
    selected?: boolean,
    onClick: () => void
}

export const Winning = ({ winning, type, selected, onClick }: WinningProps) => {
    return (
        <StyledButton
            disabled={!winning}
            selected={selected}
            type={type}
            onClick={onClick}>
            <StyledCardWithWinning
                type={type}
                winning={winning}
                selected={selected}
                withBorder>
                <WinningDescription winning={winning} type={type} small />
            </StyledCardWithWinning>
        </StyledButton>
    )
}

const StyledCardWithWinning = styled(CardWithWinning)`
    height: 200px;
`
const StyledButton = styled.button`
    position: relative;
    border: none;
    background: transparent;
    box-sizing: border-box;
    border-radius: 16px;
    padding: 0;
    cursor: pointer;
    margin: ${({ selected }) => (selected ? 0 : '2px')};
    transition: transform 50ms ease, border 50ms ease;
    width: 100%;
    max-width: 300px;
    gap: 12px;

    @media (max-width: ${breakpoints.small}px) {
        height: 156px;
    }
`
